import searchRoutes from '../search/routes'

/* @ngInject */
const listRun = (
  $transitions,
  storageHandler,
  $$dispatch,
  toaster
) => {
  $transitions.onSuccess({
    entering: searchRoutes.home.path,
  }, (trans) => {

  })

  $transitions.onBefore({
    from: searchRoutes.home.path,
  }, (trans) => {

  })
}

export default listRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/search/search.run.js